import { z } from 'zod';

export const CouponNameTypeSchema = z.enum(['FOLLOWER', 'NICKNAME', 'BRAND']);

export const ApproveProposalServiceRequestSchema = z
  .object({
    campaignProposalId: z.number(),
    couponNameType: CouponNameTypeSchema,
  })
  .describe('ApproveProposalServiceRequestSchema');

export type ApproveProposalServiceRequest = z.infer<typeof ApproveProposalServiceRequestSchema>;

export const ApproveProposalServiceResponseSchema = z.object({
  couponNo: z.number(),
  couponName: z.string(),
  couponKeyword: z.string(),
});

export type ApproveProposalServiceResponse = z.infer<typeof ApproveProposalServiceResponseSchema>;
